import { action, observable, runInAction } from 'mobx';
import { ErrorInterface } from 'modules/core/api/globalApi';
import controller from './controller';

/** Элемент списка проектов Ник-Ассистанс (GET /v1/nik/projects; бывший Redux-слайс permissions). */
export interface ProjectItemInterface {
  id: string | number,
  name?: string,
  /** Дата удаления — удалённые проекты скрыты в ProjectSelector, пока не передан showDeleted. */
  deletedDate?: string | null,
}

export interface ProjectStore {
  projects: ProjectItemInterface[],
  // true — только после успешного ответа: при ошибке остаётся false, и следующий mount повторит запрос
  projectsLoaded: boolean,
  loadingProjects: boolean,

  error: ErrorInterface,
}

const initialValues: ProjectStore = {
  projects: [],
  projectsLoaded: false,
  loadingProjects: false,

  error: null,
};

export const projectStore = observable(initialValues);

// запрос в полёте (не обзервабл: на рендер не влияет) — single-flight на дублирующие mount'ы
let projectsInFlight = false;

export const projectActions = {

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      projectStore.error = {
        message: errorData?.message,
        errorCode: errorData?.errorCode,
        timestamp: errorData?.timestamp,
        status: response?.status,
        connectError: response?.connectError,
        isError: response?.error,
      };
      throw errorData;
    }
  }),

  // GET /v1/nik/projects — проекты Ник-Ассистанс. Load-once: один запрос за сессию.
  // В Redux список качался заново на каждый mount ProjectSelector (при пустом списке).
  async getProjects() {
    if (projectStore.projectsLoaded || projectsInFlight) {
      return;
    }
    projectsInFlight = true;
    runInAction(() => {
      projectStore.loadingProjects = true;
    });
    try {
      const response = await controller.getProjects();

      projectActions.handleError(response);
      runInAction(() => {
        projectStore.projectsLoaded = true;
        projectStore.projects = response?.data ?? [];
      });
    } catch (err) {
      this.handleError(err);
    } finally {
      projectsInFlight = false;
      runInAction(() => {
        projectStore.loadingProjects = false;
      });
    }
  },

};
